var _rect, _text, _text2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNavbarHk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 420,
    viewBox: "0 0 1600 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 420,
    fill: "#F7F7F7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 280,
    fontFamily: "Baskerville, Georgia, serif",
    fontSize: 220,
    fontWeight: 400,
    fill: "#8F8884",
    letterSpacing: 1
  }, "\n    Fundaci\xF3n\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 1130,
    y: 280,
    fontFamily: "Baskerville, Georgia, serif",
    fontSize: 220,
    fontWeight: 700,
    fill: "#F04A00",
    letterSpacing: 2
  }, "\n    HK\n  ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 345,
    x2: 380,
    y2: 345,
    stroke: "#F04A00",
    strokeWidth: 18,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNavbarHk);
export default __webpack_public_path__ + "static/media/logo-navbar-hk.5682d914a8a01996117325b2009ec13b.svg";
export { ForwardRef as ReactComponent };